export default __webpack_public_path__ + "static/media/NotoSerif-BoldItalic.a1dcaad8.eot";